import { SCHOOL_SEARCH, School_SearchActionType } from "./types";

export const schoolSearchReducer = (state = {}, action: School_SearchActionType) => {
    switch (action.type) {
        case SCHOOL_SEARCH.REQUEST:
        case SCHOOL_SEARCH.SUCCESS:
        case SCHOOL_SEARCH.FAILURE:
            return {
                ...state,
                ...action.payload,
            };
        default:
            return state;
    }
};
